import { useEffect } from 'react';
import { useMapShapeStore } from '..';
import Shape from '../interfaces/Shape';

export function usePopupShapesOnMap(shapes: Shape[] | undefined, lock: string) {
    const store = useMapShapeStore();

    useEffect(() => {
        const detailsShapes = store.lock === lock ? store.detailsShapes : [];
        store.draw(shapes ?? [], detailsShapes, lock);
        return () => {
            if (store.detailsShapes.length)
                store.clearPopup(lock);
        };
    }, [shapes, lock, store]);
}

export function useDetailsShapesOnMap(shapes: Shape[] | undefined, lock: string) {
    const store = useMapShapeStore();

    useEffect(() => {
        const popupShapes = store.lock === lock ? store.popupShapes : [];
        store.draw(popupShapes, shapes ?? [], lock);
    }, [shapes, lock, store]);
}
